import { RecipientBenefit } from "./DepricatedModels/RecipientBenefit";
import * as  Moment from 'moment'
import { VocationalRehab } from "./DepricatedModels/VocationalRehab";
import { GovtService } from "./DepricatedModels/GovtService";
import { FelonyConviction } from "./DepricatedModels/FelonyConviction";
import { Unemployment } from "./DepricatedModels/Unemployment";
import { EmployeeLookup } from "./EmployeeLookup";

export class CreditQuestionnaire{
    // Question 1
    Under40: boolean;
    _dateOfBirth: Moment.Moment;
    AcceptedDocuments : boolean;
    Esignature :string;
    public get DateOfBirth() : Moment.Moment {
        return this._dateOfBirth; 
    }
    
    public set DateOfBirth(v : Moment.Moment) {
        this._dateOfBirth = v;
        // are they 40? 
        var fortyYearsAgo = Moment().subtract(40,'years');
        this.Under40 = Moment(this._dateOfBirth).isAfter(fortyYearsAgo);
    }
    
    //Question 2. 
    BenefitData : RecipientBenefit[] = [];
    // Question 3.
    VocationalData : VocationalRehab;
    //Question 4.
    ServiceData : GovtService
    //Question 5.
    RecievedSSI60Days:boolean;
    //Question 6.
    FelonyData : FelonyConviction;
    // Question 7.
    UnemploymentData : Unemployment;
    // Question 8.
    NativeAmerican: boolean;
    // Get them digits!!!
    EmployeeData : EmployeeLookup;

    recievedInteraction: boolean;

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/Models/TaxCreditQuestionnaire.ts